import { ajaxUpdate } from '../../utilities/ajax'
import { initBehaviors } from '../'
import events from '../../constants/events'
import { dispatchEvent } from '../../utilities/customEvents'

import { Base } from './Base'

export class AddToCartAndRefresh extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element)
    this.init()
  }

  init() {
    this.bindFunctions()
    this.handleSubmit()

    this.updatePriceOnChange()
  }

  handleSubmit() {
    this.element.addEventListener('submit', e => {
      e.preventDefault()
      this.addToCart()
    })
  }

  bindFunctions() {
    this.addToCart = this.addToCart.bind(this)
    this.handleVariantChange = this.handleVariantChange.bind(this)
  }

  updatePriceOnChange() {
    const { hiddenInput } = this.refs

    hiddenInput.addEventListener('input', this.handleVariantChange)
  }

  handleVariantChange(e) {
    const { price, json, image, images } = this.refs

    const { price: newPrice } =
      JSON.parse(json.textContent).variants.find(
        variant => variant.id === parseInt(e.target.value)
      ) || {}
    
      const { image_url } =
      JSON.parse(images.textContent).variants.find(
        variant => variant.id === parseInt(e.target.value)
      ) || {}

    if (newPrice) {
      price.textContent = newPrice
    }

    if (image_url) {
      const img = image.querySelector('img')
      if (img) {
        img.removeAttribute('srcset')
        img.src = image_url
      }
    }
  }

  addToCart() {
    const { hiddenInput, quantity } = this.refs

    const properties = {}

    this.element.querySelectorAll('[name^="properties"]').forEach(property => {
      //RegEx on name attribute to remove 'properties[...]'

      if (property.type === 'checkbox') {
        properties[property.name.match(regEx)[1]] = property.checked
      } else {
        properties[property.name.match(regEx)[1]] = property.value
      }
    })

    let id = hiddenInput.value

    ajaxUpdate('/cart/add', {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        quantity: quantity.value,
        id: id,
        properties,
      }),
      callback: () => {
        dispatchEvent(window, events.CART_UPDATED, {
          numberOfItemsAdded: quantity,
        })

        dispatchEvent(window, events.AJAX_UPDATED)

        initBehaviors()
      },
      history: false,
      method: 'POST',
      selectors: ['[data-ref-cart="form"]', '[data-ref-number-input="output"]'],
    })
  }

  cleanup() {}
}
